import React, {Component} from 'react';
import 'whatwg-fetch';
import './SocialLoginDisplayComponent.less';
import authAccountTypes from '../../enums/AuthAccountTypes';
import GoogleAuthComponent from '../GoogleAuthComponent/GoogleAuthComponent';
import FacebookAuthComponent from '../FacebookAuthComponent/FacebookAuthComponent';
import CreatePasswordComponent from '../CreatePasswordComponent/CreatePasswordComponent';
import ExpediaAuthComponent from '../ExpediaAuthComponent/ExpediaAuthComponent';

class SocialLoginPageDisplayComponent extends Component {

    constructor(props) {
        super(props);
        const initialState = {
            emailAddress: this.props.emailAddress,
            password: '',
            loggedIn: false,
            googleToken: null,
            facebookToken: null,
            expediaToken: null
        };
        this.displayFacebook = this.displayFacebook.bind(this);
        this.hasAccount = this.hasAccount.bind(this);
        this.displayGoogle = this.displayGoogle.bind(this);
        this.displayExpedia = this.displayExpedia.bind(this);

        const {token} = props;
        if (this.hasAccount(authAccountTypes.GOOGLE)) {
            this.state = {
                ...initialState,
                googleToken: token
            };
        } else if (this.hasAccount(authAccountTypes.FACEBOOK)) {
            this.state = {
                ...initialState,
                facebookToken: token
            };
        } else {
            this.state = {
                ...initialState,
                expediaToken: token
            };
        }
    }

    hasAccount(account) {
        return (this.props.authAccountType.some((t) => (t === account)));
    }

    displayExpedia() {
        if (this.hasAccount(authAccountTypes.EXPEDIA)) {
            return (
                <ExpediaAuthComponent
                    authStatus
                    lingua={this.props.lingua}
                    handleError={this.props.handleError}
                    onClose={this.props.onClose}
                    setAuthJson={this.props.setAuthJson}
                    performBulkPageUpdate={this.props.performBulkPageUpdate}
                    site={this.props.site}
                    token = {this.state.expediaToken}
                    emailAddress = {this.state.emailAddress}
                />
            );
        }
        return null;
    }

    displayFacebook() {
        if (this.hasAccount(authAccountTypes.FACEBOOK)) {
            return (
                <FacebookAuthComponent
                    authStatus
                    lingua={this.props.lingua}
                    handleError={this.props.handleError}
                    onClose={this.props.onClose}
                    setAuthJson={this.props.setAuthJson}
                    performBulkPageUpdate={this.props.performBulkPageUpdate}
                    site={this.props.site}
                    token = {this.state.facebookToken}
                    emailAddress = {this.state.emailAddress}
                />
            );
        }
        return null;
    }

    displayGoogle() {
        if (this.hasAccount(authAccountTypes.GOOGLE)) {
            return (
                <GoogleAuthComponent
                    authStatus
                    lingua={this.props.lingua}
                    handleError={this.props.handleError}
                    onClose={this.props.onClose}
                    setAuthJson={this.props.setAuthJson}
                    performBulkPageUpdate={this.props.performBulkPageUpdate}
                    site={this.props.site}
                    token = {this.state.googleToken}
                    emailAddress = {this.state.emailAddress}
                />
            );
        }
        return null;
    }

    displayCreatePassword() {
        if (this.hasAccount(authAccountTypes.GOOGLE) || this.hasAccount(authAccountTypes.FACEBOOK) || this.hasAccount(authAccountTypes.EXPEDIA)) {
            return (
                <CreatePasswordComponent lingua={this.props.lingua} updatePage={this.props.updatePage} handleError={this.props.handleError} service={this.props.service} emailAddress={this.state.emailAddress}
                    displayButton={!!this.props.multiUserEnabled}
                />
            );
        }
        return null;
    }

    render() {
        let header = this.props.lingua.read('lex.social.login.card.header2');
        let muHeader = this.props.lingua.read('lex.social.login.card.muHeader');

        if (this.props.multiUserEnabled) {
            return (
                <div className="text-center">
                    <div className="Existing-social-mu"> {muHeader} </div>
                    <div> {this.displayCreatePassword()} </div>
                </div>
            );
        }
        return (
            <div className="text-center">
                <div>
                    <div className="Select-your-social-a"> {header} </div>
                </div>
                <div className="SocialButtons">
                    {this.displayExpedia()}
                    {this.displayGoogle()}
                    {this.displayFacebook()}
                </div>
                <div> {this.displayCreatePassword()} </div>
            </div>
        );
    }
}

export default SocialLoginPageDisplayComponent;
